import React, { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/PageHero";
import { api } from "@/lib/api";
import { CheckCircle2, Shield } from "lucide-react";

export default function Methodology() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/methodology").then(r => setM(r.data)); }, []);
  if (!m) return <Layout hideRightPanel><div className="skeleton h-40 mt-8"/></Layout>;

  return (
    <Layout hideRightPanel>
      <PageHero
        testId="methodology-hero"
        eyebrow={<><Shield size={12} /> Methodology &amp; Impartiality</>}
        badge="Full Transparency"
        title={<>How we <span className="italic">score.</span> How we <span className="italic">stay honest.</span></>}
        sub="Wikifi is only worth trusting if you can see behind the scores. Here's exactly how they're computed and how we keep them impartial."
      />

      <section className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10" data-testid="scoring-section">
        <div className="curio-card p-6">
          <div className="text-xs uppercase tracking-widest text-coral font-bold mb-2">Wikifi Score</div>
          <div className="font-display text-4xl font-bold mb-3">0–100</div>
          <p className="text-sm">{m.scoring.curio_score}</p>
        </div>
        <div className="curio-card p-6">
          <div className="text-xs uppercase tracking-widest text-coral font-bold mb-2">Value Score</div>
          <div className="font-display text-4xl font-bold mb-3">0–100</div>
          <p className="text-sm mb-4">{m.scoring.value_score}</p>
          <div className="space-y-2 text-xs">
            {[["Usefulness", 35], ["Reliability", 25], ["Pricing value", 25], ["Ease of use", 15]].map(([l,p]) => (
              <div key={l}>
                <div className="flex justify-between mb-1"><span>{l}</span><span className="font-bold">{p}%</span></div>
                <div className="h-1.5 bg-[var(--curio-bg)] rounded-full overflow-hidden"><div className="h-full bg-[var(--curio-coral)]" style={{width: `${p}%`}}/></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="curio-card p-8 mb-10">
        <h2 className="font-display text-3xl font-bold mb-4">Our Impartiality Promise</h2>
        <ul className="space-y-3">
          {m.impartiality_promise.map((p) => (
            <li key={p} className="flex gap-3"><CheckCircle2 size={18} className="text-coral flex-shrink-0 mt-0.5"/><span className="text-sm leading-relaxed">{p}</span></li>
          ))}
        </ul>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="curio-card p-6">
          <h3 className="font-display text-2xl font-semibold mb-3">Sourcing</h3>
          <ul className="space-y-2 text-sm">{m.sourcing.map(s => <li key={s} className="flex gap-2"><span className="text-coral font-bold">·</span>{s}</li>)}</ul>
        </div>
        <div className="curio-card p-6">
          <h3 className="font-display text-2xl font-semibold mb-3">Verification cadence</h3>
          <p className="text-sm mb-3">{m.verification_cadence}</p>
          <div className="text-xs px-3 py-1.5 rounded-full bg-[var(--curio-bg)] border border-[var(--curio-border)] inline-block">Entries verified in the last 90 days show a <strong>Verified</strong> badge on the tool page.</div>
        </div>
      </section>
    </Layout>
  );
}
